import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import PatientIntakeService from '@/services/PatientIntakeService';
import type { ListPatientIntakesOpts } from '@/services/PatientIntakeService';
import { PATIENT_INTAKE_KEYS } from './keys';

export function usePatientIntakes(
  userid: string | number | null | undefined,
  opts: ListPatientIntakesOpts = {},
) {
  return useQuery({
    queryKey: PATIENT_INTAKE_KEYS.list(userid ?? '', opts as unknown as Record<string, unknown>),
    queryFn: () => PatientIntakeService.listPatientIntakes(userid!, opts),
    enabled: userid != null && userid !== '',
  });
}

// Imperative one-shot for paginated / filter-debounce flows (PatientIntakesList).
export function useFetchPatientIntakes() {
  const qc = useQueryClient();
  return useCallback(
    (userid: string | number, opts: ListPatientIntakesOpts = {}) => qc.fetchQuery({
      queryKey: PATIENT_INTAKE_KEYS.list(userid, opts as unknown as Record<string, unknown>),
      queryFn: () => PatientIntakeService.listPatientIntakes(userid, opts),
    }),
    [qc],
  );
}
